import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getStudentClassesAndAttendance = async (enrollmentId) => {
  const res = await axios.apiCadernoVirtual(
    "/diary-service/diary/listClassAndPresence",
    { params: { enrollmentId } }
  );
  return res.object;
};

export const useStudentClassesAndAttendance = ({
  config,
  enrollmentId,
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["studentClassesAndAttendance", { enrollmentId }],
    queryFn: () => getStudentClassesAndAttendance(enrollmentId),
  });
};
